module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tooltip":"Company side activity"},"ja":{"tooltip":"企業側活動の表示設定"},"zh-hant":{"tooltip":"企業活動的顯示設定"},"zh-hans":{"tooltip":"企业活动的显示设定"}}')
  delete Component.options._Ctor
}
